import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StorageGuard } from './security/storage.guard';
import { VerifyPassportComponent } from 'pages/verify-passport/verify-passport.component';

const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/initial/initial.component').then((m) => m.InitialComponent),
    data: { subFunnel: 'Home' },
  },
  {
    path: 'languages',
    loadComponent: () =>
      import('./pages/languages/languages.component').then((m) => m.LanguagesComponent),
  },
  {
    path: 'pnr-lookup',
    loadComponent: () =>
      import('./pages/code-reservation/code-reservation.component').then(
        (m) => m.CodeReservationComponent
      ),
  },
  {
    path: 'notice-child',
    loadComponent: () =>
      import('./pages/notice-child/notice-child.component').then((m) => m.NoticeChildComponent),
    data: { subFunnel: 'unaccompanied_minor' },
  },
  {
    path: 'notice-gua',
    loadChildren: () =>
      import('./pages/notice-gua/notice-gua.module').then((m) => m.NoticeGuaModule),
  },
  {
    path: 'notice-closed',
    loadComponent: () =>
      import('./pages/notice-closed/notice-closed.component').then((m) => m.NoticeClosedComponent),
    data: { subFunnel: 'reservation_status' },
  },
  {
    path: 'notice-boardingpass',
    canActivateChild: [StorageGuard],
    loadComponent: () =>
      import('pages/stb/notice-boardingpass/notice-boardingpass.component').then(
        (m) => m.NoticeBoardingpassComponent
      ),
  },
  {
    path: 'notice-proposed-flight',
    canActivateChild: [StorageGuard],
    loadComponent: () =>
      import('pages/notice-proposed-flight/notice-proposed-flight.component').then(
        (m) => m.NoticeProposedFlightComponent
      ),
  },
  {
    path: 'notice-closed-onboarding',
    loadComponent: () =>
      import('./pages/notice-onboarding/notice-onboarding.component').then(
        (m) => m.NoticeOnboardingComponent
      ),
    // data: { subFunnel: 'reservation_status' }
  },
  {
    path: 'notice-myb-closed',
    loadComponent: () =>
      import('./pages/notice-myb-closed/notice-myb-closed.component').then(
        (m) => m.NoticeMybClosedComponent
      ),
    // data: { subFunnel: 'reservation_status' }
  },
  {
    path: 'find-destination',
    loadComponent: () =>
      import('./pages/find-by-destination/find-by-destination.component').then(
        (m) => m.FindByDestinationComponent
      ),
    data: { subFunnel: 'PNR_lookup' },
  },
  {
    path: 'scan-documents/:type',
    loadComponent: () =>
      import('./pages/scan-documents/scan-documents.component').then(
        (m) => m.ScanDocumentsComponent
      ),
  },
  {
    path: 'flight-info',
    loadComponent: () =>
      import('./pages/flight-info/flight-info.component').then((m) => m.FlightInfoComponent),
  },
  {
    path: 'flight-select',
    loadComponent: () =>
      import('./pages/flight-select/flight-select.component').then((m) => m.FlightSelectComponent),
  },
  {
    path: 'choose-passagers',
    loadComponent: () =>
      import('./pages/choose-passagers/choose-passagers.component').then(
        (m) => m.ChoosePassagersComponent
      ),
    data: { subFunnel: 'passenger_selection' },
  },
  {
    path: 'gender',
    loadComponent: () => import('./pages/gender/gender.component').then((m) => m.GenderComponent),
  },
  {
    path: 'frequent-flyer',
    loadComponent: () =>
      import('./pages/frequent-flyer/frequent-flyer.component').then(
        (m) => m.FrequentFlyerComponent
      ),
    data: { subFunnel: 'ffn_postcki' },
  },
  {
    path: 'verify-passport',
    loadComponent: () =>
      import('./pages/verify-passport/verify-passport.component').then(
        (m) => m.VerifyPassportComponent
      ),
  },
  {
    path: 'information',
    canActivateChild: [StorageGuard],
    loadComponent: () =>
      import('./pages/important-info/important-info.component').then(
        (m) => m.ImportantInfoComponent
      ),
    data: { subFunnel: 'privacy_policy' },
  },
  {
    path: 'information/privacy-policy',
    loadComponent: () =>
      import('./pages/important-info/privacity-policity/privacity-policity.component').then(
        (m) => m.PrivacityPolicityComponent
      ),
  },
  {
    path: 'payment',
    canActivateChild: [StorageGuard],
    loadChildren: () => import('./pages/payment/payment.module').then((m) => m.PaymentModule),
  },
  {
    path: 'manage-extras/select/:productCode',
    canActivateChild: [StorageGuard],
    loadComponent: () =>
      import('./pages/manage-extras/insurance-selection/insurance-selection.component').then(
        (m) => m.InsuranceSelectionComponent
      ),
    data: { subFunnel: 'manage_extras_selection' },
  },
  {
    path: 'manage-extras/success',
    canActivateChild: [StorageGuard],
    loadComponent: () =>
      import('./pages/manage-extras/insurance-success/insurance-success.component').then(
        (m) => m.InsuranceSuccessComponent
      ),
    data: { subFunnel: 'manage_extras_success' },
  },
  {
    path: 'manage-extras',
    canActivateChild: [StorageGuard],
    loadComponent: () =>
      import('./pages/manage-extras/manage-extras.component').then((m) => m.ManageExtrasComponent),
    data: { subFunnel: 'manage_extras' },
  },
  {
    path: 'seat',
    canActivateChild: [StorageGuard],
    loadChildren: () => import('pages/seats/seats.module').then((m) => m.SeatsModule),
  },
  {
    path: 'rbmenuPassengerSelection',
    loadComponent: () =>
      import('./pages/rb-menu-passenger-selection/rb-menu-passenger-selection.component').then(
        (m) => m.RbMenuPassengerSelectionComponent
      ),
    data: { subFunnel: 'travelhub_menu' },
  },
  {
    path: 'review-bags',
    canActivateChild: [StorageGuard],
    loadChildren: () => import('./pages/bags/bags.module').then((m) => m.BagsModule),
  },
  {
    path: 'printingBoardinPasses',
    loadComponent: () =>
      import('./pages/printing-boarding-passes/printing-boarding-passes.component').then(
        (m) => m.PrintingBoardingPassesComponent
      ),
    data: { subFunnel: 'travelhub_menu' },
  },
  {
    path: 'printingBoardinPasses2',
    loadComponent: () =>
      import('./pages/printing-boarding-passes2/printing-boarding-passes2.component').then(
        (m) => m.PrintingBoardingPasses2Component
      ),
    data: { subFunnel: 'successful_seat_change' },
  },
  {
    path: 'printingBoardinPasses3',
    loadComponent: () =>
      import('./pages/printing-boarding-passes3/printing-boarding-passes3.component').then(
        (m) => m.PrintingBoardingPasses3Component
      ),
    data: { subFunnel: 'successful_seat_change' },
  },
  {
    path: 'pax',
    canActivateChild: [StorageGuard],
    loadChildren: () => import('./pages/pax/pax.module').then((m) => m.PaxModule),
  },
  {
    path: 'stb',
    canActivateChild: [StorageGuard],
    loadChildren: () => import('./pages/stb/stb.module').then((m) => m.StbModule),
  },
  {
    path: 'srIrops',
    loadChildren: () => import('./pages/srIrops/srIrops.module').then((m) => m.SrIropsModule),
  },

  {
    path: 'cuss',
    loadComponent: () => import('./cuss/pocEmbross.component').then((m) => m.EmbrossComponent),
  },

  {
    path: 'flight-status',
    loadComponent: () =>
      import('./pages/flight-status/flight-status.component').then((m) => m.FlightStatusComponent),
  },
  {
    path: 'scan-passport',
    loadComponent: () =>
      import('./pages/scan-passport/scan-passport.component')
        .then((m) => m.ScanPassportComponent)
        .catch((error) => {
          // CI-23100: reenviar el fallo de carga del chunk al GlobalErrorHandler
          // (guard anti-loop de CI-22821), evitando duplicar la política de recarga.
          throw error;
        }),
    data: { subFunnel: 'QR_lookup' },
  },
  {
    path: 'poc/inputs',
    loadComponent: () => import('./pocs/inputs/inputs.component').then((m) => m.InputsComponent),
  },
  {
    path: 'ga4',
    loadComponent: () => import('./pocs/ga4/ga4.component').then((m) => m.Ga4Component),
  },

  {
    path: 'seamless',
    loadChildren: () => import('./pages/seamless/seamless.module').then((m) => m.SeamlessModule),
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
